var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "135px",
    viewBox: "0 0 135 135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#B2E4C1",
    cx: 67.5,
    cy: 67.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8940148,35 L75.5780905,35 C72.220408,35 67.5302151,36.9418902 65.1556653,39.31644 L36.7809124,67.6911929 C34.4063625,70.0657427 34.4063625,73.9515543 36.7809124,76.3261041 L58.6738959,98.2190876 C61.0484457,100.593637 64.9342573,100.593637 67.3088071,98.2190876 L95.6815288,69.846366 C98.0581098,67.4718162 100,62.7816233 100,59.4219095 L100,41.1059852 C100,37.7483027 97.2516973,35 93.8940148,35 Z M85.7811389,55.3126587 C82.4153314,55.3126587 79.6873413,52.5846687 79.6873413,49.2188611 C79.6873413,45.8530536 82.4153314,43.1250635 85.7811389,43.1250635 C89.1469465,43.1250635 91.8749365,45.8530536 91.8749365,49.2188611 C91.8749365,52.5846687 89.1469465,55.3126587 85.7811389,55.3126587 Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTag);
export default __webpack_public_path__ + "static/media/header-tag.048ac46810aa73cabc75e88ed02a420e.svg";
export { ForwardRef as ReactComponent };